import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import {
  CurrencyBitcoin as CryptoIcon,
  TrendingUp as StocksIcon,
  SwapHoriz as ForexIcon,
  Spa as CommoditiesIcon,
} from '@mui/icons-material';

const MARKETS = [
  {
    id: 'crypto',
    label: 'Crypto',
    icon: CryptoIcon,
    description: 'Bitcoin, Ethereum, altcoins',
    color: 'var(--dwlf-accent)',
  },
  {
    id: 'stocks',
    label: 'Stocks',
    icon: StocksIcon,
    description: 'US equities, tech, growth',
    color: 'var(--dwlf-up)',
  },
  {
    id: 'forex',
    label: 'Forex',
    icon: ForexIcon,
    description: 'Major currency pairs',
    color: 'var(--dwlf-warn)',
  },
  {
    id: 'commodities',
    label: 'Commodities',
    icon: CommoditiesIcon,
    description: 'Gold, oil, precious metals',
    color: 'var(--dwlf-down)',
  },
];

const MarketSelectionStep = ({ selectedMarkets, onSelectMarkets }) => {
  const toggleMarket = (marketId) => {
    if (selectedMarkets.includes(marketId)) {
      onSelectMarkets(selectedMarkets.filter((m) => m !== marketId));
    } else {
      onSelectMarkets([...selectedMarkets, marketId]);
    }
  };

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Space Grotesk", sans-serif',
          fontWeight: 600,
          mb: 1,
        }}
      >
        What markets are you interested in?
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'var(--dwlf-ink-60)',
          mb: 4,
          fontFamily: '"IBM Plex Mono", monospace',
        }}
      >
        Select one or more markets to track. You can change this later.
      </Typography>

      <Grid container spacing={2}>
        {MARKETS.map((market) => {
          const Icon = market.icon;
          const isSelected = selectedMarkets.includes(market.id);

          return (
            <Grid size={{ xs: 12, sm: 6 }} key={market.id}>
              <Paper
                onClick={() => toggleMarket(market.id)}
                sx={{
                  p: 3,
                  cursor: 'pointer',
                  bgcolor: isSelected
                    ? `color-mix(in srgb, ${market.color} 10%, transparent)`
                    : 'var(--dwlf-elevated)',
                  border: isSelected
                    ? `2px solid ${market.color}`
                    : '2px solid transparent',
                  outline: isSelected ? 'none' : '1px solid var(--dwlf-ink-08)',
                  borderRadius: 0,
                  transition: 'all 0.2s',
                  '&:hover': {
                    bgcolor: isSelected
                      ? `color-mix(in srgb, ${market.color} 15%, transparent)`
                      : 'var(--dwlf-ink-05)',
                    borderColor: market.color,
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Icon
                    sx={{
                      fontSize: 32,
                      color: isSelected ? market.color : 'var(--dwlf-ink-50)',
                      mr: 2,
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Space Grotesk", sans-serif',
                      fontWeight: 600,
                      color: isSelected ? market.color : 'var(--dwlf-text)',
                    }}
                  >
                    {market.label}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'var(--dwlf-ink-60)',
                    fontFamily: '"IBM Plex Mono", monospace',
                    fontSize: '0.85rem',
                  }}
                >
                  {market.description}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MarketSelectionStep;
